import {
  CustomSectionNode,
  CustomSectionType,
  CustomSectionNodeType,
  GroupByOption,
  GenerateAsOption,
  ParticipantGroupOption,
  CustomSectionContentState,
} from 'api/custom-section/types';

export const defaultSections: CustomSectionNode[] = [
  {
    type: CustomSectionNodeType.RlCustomSection,
    attrs: {
      templateSectionId: 'new_section_0',
      contentState: CustomSectionContentState.Prompt,
      sectionType: CustomSectionType.EmailDetails,
      title: 'Email Details',
      config: {
        fields: ['subject', 'firstEmail', 'latestReply', 'participants'],
      },
    },
    content: [
      {
        type: 'paragraph',
        attrs: {
          textAlign: null,
        },
      },
    ],
  },
  {
    type: CustomSectionNodeType.RlCustomSection,
    attrs: {
      templateSectionId: 'new_section_1',
      contentState: CustomSectionContentState.Prompt,
      sectionType: CustomSectionType.Question,
      title: 'Summary',
      config: {
        question: 'Provide a 100-word summary of the events in the emails',
        aiContext: 'Focus on the contributions of each participant',
        groupBy: GroupByOption.Topics,
        generateAs: GenerateAsOption.Paragraph,
        participants: ParticipantGroupOption.All,
      },
    },
    content: [
      {
        type: 'RL_PLACEHOLDER_CONFIG',
        attrs: {
          icon: 'faAlignLeft',
          iconPosition: 'left',
        },
        content: [{ type: 'text', text: 'Topic 1' }],
      },
      {
        type: 'RL_PLACEHOLDER_CONFIG',
        attrs: {
          icon: '',
          iconPosition: 'left',
          disabled: true,
        },
        content: [
          {
            type: 'text',
            text: '...',
          },
        ],
      },
      {
        type: 'RL_PLACEHOLDER_CONFIG',
        attrs: {
          icon: 'faAlignLeft',
          iconPosition: 'left',
        },
        content: [{ type: 'text', text: 'Topic 2' }],
      },
    ],
  },
];

export const defaultContent = {
  type: 'doc',
  content: defaultSections,
};

export const DEFAULT_SECTION_IDS = ['new_section_0', 'new_section_1'];

export const defaultChoices = [
  {
    label: 'Hubspot',
    position: 1,
    value: 1,
  },
  {
    label: 'Salesforce',
    position: 2,
    value: 2,
  },
];
